const ARTICLE_PUBLISHED_AT = {
  'yinpin-zhuan-wenzi-xue-yingyu': '2026-07-09',
  'mp3-zimu-lian-tingli-kouyu': '2026-07-09',
  'yingyu-genduxunlian-zenme-zuo': '2026-07-09',
  'yasi-kouyu-yong-tts-lianxi': '2026-07-09',
  'bilingual-subtitles-listening-speaking': '2026-07-09',
  'jingting-yingyu-zenme-zuo': '2026-07-09',
  'boke-lian-kouyu-fangfa': '2026-07-09',
  'yingyu-tingli-tingbudong-zenmeban': '2026-07-09',
  'yasi-tingli-cuoti-jingting': '2026-07-09',
  'yingyu-mianshi-kouyu-lianxi': '2026-07-09',
  'yingyu-duanju-fuxi-fangfa': '2026-07-09',
  'meitian-kai-kou-shuo-yingyu': '2026-07-13',
  'bbc-liu-fenzhong-yingyu-gendu': '2026-10-07'
}

const EVIDENCE_SOURCES = {
  shadowing: {
    title: '视频跟读对英语超音段发音特征的影响',
    publisher: 'rEFLections，2024',
    url: 'https://doi.org/10.61508/refl.v31i3.275498',
    note: '研究对象为中低水平英语学习者，结果显示超音段发音表现有所改善，语调变化较明显。结论只适用于该研究的参与者与训练设计。'
  },
  captions: {
    title: '听还是读？英语学习者对字幕的依赖',
    publisher: 'Behavioral Sciences，2025',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12024247/',
    note: '研究包含 64 名中国英语学习者，发现字幕依赖会随英语水平和视频复杂度变化，支持按需查看字幕，避免全程只读文字。'
  },
  asr: {
    title: '自动语音识别对二语发音与口语的影响',
    publisher: 'Frontiers in Psychology，2023',
    url: 'https://doi.org/10.3389/fpsyg.2023.1210187',
    note: '这项 14 周研究包含 61 名中国中级英语学习者，干预同时使用 ASR 和同伴纠正，因此不能把结果只归因于自动反馈。'
  },
  ielts: {
    title: 'IELTS Speaking Band Descriptors',
    publisher: 'IELTS 官方',
    url: 'https://ielts.org/cdn/ielts-guides/ielts-speaking-band-descriptors.pdf',
    note: '官方公开评分描述说明雅思口语的评分维度。GoodScriber 的练习反馈不等同于官方雅思分数，也不用于预测分数。'
  }
}

const ARTICLE_EVIDENCE = {
  'yingyu-genduxunlian-zenme-zuo': ['shadowing'],
  'boke-lian-kouyu-fangfa': ['shadowing', 'captions'],
  'yinpin-zhuan-wenzi-xue-yingyu': ['captions'],
  'yasi-kouyu-yong-tts-lianxi': ['ielts'],
  'mp3-zimu-lian-tingli-kouyu': ['captions'],
  'meitian-kai-kou-shuo-yingyu': ['asr'],
  'bilingual-subtitles-listening-speaking': ['captions'],
  'jingting-yingyu-zenme-zuo': ['captions'],
  'yingyu-tingli-tingbudong-zenmeban': ['captions'],
  'yingyu-mianshi-kouyu-lianxi': ['asr'],
  'bbc-liu-fenzhong-yingyu-gendu': ['shadowing']
}

const zhLearnArticleDrafts = [
  {
    slug: 'yinpin-zhuan-wenzi-xue-yingyu',
    title: '音频转文字怎么用来学英语？',
    description: '把英语音频转成文字和字幕，就能把听不清的声音变成可阅读、可搜索、可逐句练习的材料。本文讲清先听大意、再看转写定位难句、最后按句回放和跟读的完整流程，适合播客、课程录音和雅思托福听力材料。',
    tldr: '音频转文字的核心价值，是把听不清的声音变成可阅读、可搜索、可重复练习的材料。先听一遍，再看转写文本定位难句，最后按句回放和跟读，比单纯听完整段音频更容易提升听力和口语。',
    sections: [
      {
        heading: '为什么适合语言学习',
        body: [
          '很多人听英语材料时，最大问题是听过就过去了，难句和生词没有被留下来。转写文本可以把听力材料变成可复盘的学习素材。',
          'GoodScriber 可以把音频生成字幕和文本，再配合逐句播放、翻译和跟读，让你围绕具体句子练习。'
        ]
      },
      {
        heading: '推荐练习步骤',
        list: [
          '先不看文本，完整听一遍音频。',
          '生成转写文本和字幕。',
          '标出漏听的句子、生词和连读位置。',
          '逐句回放，跟读 3 到 5 次。',
          '把高频表达保存下来，隔天复习。'
        ]
      },
      {
        heading: '不同材料怎么用',
        table: {
          headers: ['材料类型', '适合目标', 'GoodScriber 用法'],
          rows: [
            ['英语播客', '自然表达和语速', '转字幕后逐句跟读'],
            ['雅思托福听力', '考试精听', '定位错题句和关键词'],
            ['课程录音', '理解和复习', '导出文本做笔记']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '比如你上传一段 3 分钟英语播客，GoodScriber 生成字幕后，你可以先看出自己漏听了哪些词，再对着字幕反复听同一句，最后关掉翻译进行跟读。'
        ]
      }
    ],
    faqs: [
      ['音频转文字能直接提高口语吗？', '它本身只是把声音变成文本。真正提高口语的是后续的逐句回放、跟读、复述和纠音。'],
      ['学英语应该先听还是先看文本？', '建议先听一遍，再看文本。直接看文本容易变成阅读练习，听力刺激会变弱。'],
      ['播客适合做音频转文字练习吗？', '适合。播客有自然语速、真实停顿和日常表达，很适合做精听和跟读。'],
      ['转写文本需要逐字校对吗？', '学习用途不需要逐字完美，但人名、数字、专业词和听不清的位置建议检查。'],
      ['GoodScriber 可以导出转写内容吗？', '可以。你可以把转写文本或字幕导出，用于复习、笔记或其它学习流程。']
    ]
  },
  {
    slug: 'mp3-zimu-lian-tingli-kouyu',
    title: 'MP3 字幕怎么用来练听力和口语？',
    description: '把 MP3 生成带时间轴的字幕后，最适合用来精听和跟读：找出没听懂的句子，逐句回放、查看难句翻译并模仿发音。本文介绍把一段音频拆成逐句听说练习材料的具体做法，不只用于剪辑或普通字幕制作。',
    tldr: 'MP3 字幕最适合做精听和跟读：先生成带时间轴的字幕，再找出没听懂的句子，反复回放并模仿发音。目标是把一段音频拆成可以逐句练习的听说材料。',
    sections: [
      {
        heading: '为什么别只把它当成字幕工具',
        body: [
          '单纯搜索“MP3 转字幕”的人可能只是要一个工具，这类词竞争很大。对学习者来说，更有价值的场景是把 MP3 变成可跟读、可复盘的材料。',
          'GoodScriber 的优势在于字幕、翻译、逐句播放和 TTS 可以放在同一个学习流程里。'
        ]
      },
      {
        heading: '推荐练习流程',
        list: [
          '选择 1 到 3 分钟的 MP3 片段。',
          '生成带时间轴的字幕。',
          '先听一遍，标出没听懂的句子。',
          '查看字幕和必要翻译，确认句子意思。',
          '逐句回放并跟读，直到节奏和重音更接近原音。'
        ]
      },
      {
        heading: '不同输出怎么服务学习',
        table: {
          headers: ['输出形式', '学习用途', '练习动作'],
          rows: [
            ['时间轴字幕', '定位难句', '反复回放同一句'],
            ['纯文本', '整理表达', '保存高频词组'],
            ['双语字幕', '理解难句', '看懂后回到英文原句跟读']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '你可以上传一段英语播客 MP3，生成字幕后筛出 5 个听不清的句子。每个句子先听原音，再看英文字幕，必要时看中文解释，最后跟读到能自然说出来。'
        ]
      }
    ],
    faqs: [
      ['MP3 字幕能提高听力吗？', '能，但前提是用它定位难句并反复回放。只看完整文本，提升会很有限。'],
      ['要不要每一句都翻译？', '不用。只翻译影响理解的句子，避免把听力训练变成中文阅读。'],
      ['MP3 片段多长合适？', '1 到 3 分钟更适合精听和跟读，太长会很难坚持细练。'],
      ['MP3 字幕适合练口语吗？', '适合。带时间轴的字幕可以帮助你锁定当前句子，模仿原音的重音、停顿和语调。'],
      ['学习用字幕需要完全准确吗？', '不需要完全逐字准确，但准备跟读的句子、人名和数字最好检查一下。']
    ]
  },
  {
    slug: 'yingyu-genduxunlian-zenme-zuo',
    title: '英语跟读训练怎么做效果最好？',
    description: '英语跟读训练最有效的方法是短材料、慢拆解、逐句重复：先听懂一句，再模仿重音、连读和停顿，最后录音对比原音。本文给出每次练 5 到 10 个句子的具体步骤，避免跟着音频从头到尾机械朗读。',
    tldr: '英语跟读训练最有效的方法是短材料、慢拆解、逐句重复。先听懂一句，再模仿重音、连读和停顿，最后录下自己对比原音。一次练 5 到 10 个句子，比整篇材料从头读到尾更有效。',
    sections: [
      {
        heading: '跟读训练练的是什么',
        body: [
          '跟读主要训练语音节奏、句子重音、停顿、连读和开口流利度。材料越短，越容易练细。'
        ]
      },
      {
        heading: '推荐训练流程',
        list: [
          '选择 1 到 3 分钟的音频。',
          '生成字幕，确认每一句的意思。',
          '先听一句，不急着开口。',
          '模仿原音读 3 到 5 遍。',
          '录下自己，重点比较重音和停顿。'
        ]
      },
      {
        heading: '常见练习方式对比',
        table: {
          headers: ['方式', '优点', '问题'],
          rows: [
            ['整段跟读', '容易进入状态', '细节容易糊过去'],
            ['逐句跟读', '能打磨发音和节奏', '需要工具控制播放'],
            ['看稿朗读', '降低理解难度', '容易忽略真实语音']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '准备英语面试时，可以把自我介绍放进 GoodScriber 生成语音，再按句跟读，直到每一句的节奏稳定下来。'
        ]
      }
    ],
    faqs: [
      ['英语跟读每天练多久合适？', '每天 30 到 45 分钟就够，关键是每一句练细，而不是追求时长。'],
      ['跟读一定要看字幕吗？', '前期可以看字幕理解句子，后期建议逐渐减少依赖。'],
      ['播客适合跟读吗？', '适合，但建议截取短片段，不要直接跟完整节目。'],
      ['跟读能提高听力吗？', '能。你在模仿发音时，会更敏感地听到重音、弱读和连读。'],
      ['GoodScriber 怎么辅助跟读？', '它可以生成字幕、逐句播放、翻译内容，并把材料变成可重复练习的句子。']
    ]
  },
  {
    slug: 'yasi-kouyu-yong-tts-lianxi',
    title: '雅思口语可以用文字转语音练习吗？',
    description: '雅思口语可以用文字转语音辅助练习：把 Part 1、Part 2、Part 3 答案生成自然语音，先听节奏和停顿，再逐句跟读，最后脱稿复述。本文说明这种方法适合练什么、不能替代什么，以及具体练习步骤。',
    tldr: '雅思口语可以用文字转语音辅助练习。你可以把 Part 1、Part 2 或 Part 3 答案生成自然语音，先听节奏和停顿，再逐句跟读，最后脱稿复述。它适合做发音和表达训练，但不能替代真实开口回答。',
    sections: [
      {
        heading: '为什么 TTS 适合雅思口语',
        body: [
          '很多考生能写出答案，但开口时语速、停顿和重音不自然。文字转语音可以给你一个稳定的音频模型，用来模仿和校准。'
        ]
      },
      {
        heading: '雅思口语练习流程',
        list: [
          '写一版自己的答案，不要太长。',
          '用文字转语音生成自然朗读。',
          '听一遍，标出停顿和重音。',
          '逐句跟读，练到能自然说出来。',
          '关掉文本，按自己的话复述。'
        ]
      },
      {
        heading: '不同题型怎么练',
        table: {
          headers: ['题型', 'TTS 用法', '练习重点'],
          rows: [
            ['Part 1', '短答案朗读', '清晰和自然'],
            ['Part 2', '长答案示范', '节奏和结构'],
            ['Part 3', '观点表达', '连接词和逻辑']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '比如你写了一段“描述一个难忘地点”的 Part 2 答案，可以先生成语音，跟读几遍后再计时自己讲 2 分钟。'
        ]
      }
    ],
    faqs: [
      ['文字转语音会让答案听起来很机械吗？', '高质量 TTS 已经比较自然，但你仍然需要用自己的语气复述，避免机械背诵。'],
      ['雅思口语可以背 TTS 生成的答案吗？', '不建议死背。可以用它练节奏和表达，再转成自己的说法。'],
      ['Part 2 最适合用 TTS 吗？', '是的，Part 2 答案较长，TTS 对练语速、停顿和结构很有帮助。'],
      ['TTS 能纠正发音吗？', 'TTS 给你参考音频，真正纠正还需要你跟读、录音和对比。'],
      ['GoodScriber 支持把文本变成练习音频吗？', '支持。你可以粘贴文本生成语音，再用跟读方式练习。']
    ]
  },
  {
    slug: 'bilingual-subtitles-listening-speaking',
    title: '双语字幕对英语听力和口语有帮助吗？',
    description: '双语字幕适合确认难句意思，但最好只作为辅助理解工具：先听原音，再看英文字幕，最后用中文翻译确认。本文介绍怎样配合回放和跟读使用双语字幕，既理解内容又不依赖中文，适合精听、跟读和积累词汇。',
    tldr: '双语字幕对英语学习有帮助，但最好作为辅助理解工具。先听原音，再看英文字幕，最后用中文翻译确认意思。这样既能理解内容，又不会完全依赖中文，适合精听、跟读和词汇积累。',
    sections: [
      {
        heading: '双语字幕的价值',
        body: [
          '双语字幕可以帮你快速确认句子意思，尤其适合长句、抽象表达和考试材料。它的重点是辅助理解，不能替代听力训练。'
        ]
      },
      {
        heading: '正确使用顺序',
        list: [
          '先听原音，不看翻译。',
          '看英文字幕，确认听到的词。',
          '再看中文翻译，理解难句。',
          '回到英文字幕，逐句跟读。',
          '最后尝试不看翻译复述。'
        ]
      },
      {
        heading: '不同字幕方式对比',
        table: {
          headers: ['方式', '适合场景', '注意点'],
          rows: [
            ['只看英文字幕', '中高级精听', '生词多时理解慢'],
            ['中英双语字幕', '理解难句', '不要只盯中文'],
            ['隐藏字幕跟读', '口语输出', '需要先熟悉材料']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '你可以上传一段 TED-Ed 或英语播客，先生成英文字幕，再翻译难句，最后回到英文原句进行跟读。'
        ]
      }
    ],
    faqs: [
      ['看双语字幕会影响听力吗？', '如果只看中文会影响。正确做法是先听，再用翻译确认意思。'],
      ['双语字幕适合初学者吗？', '适合。初学者可以用翻译降低理解门槛，但要保留英文原文。'],
      ['精听时要逐句翻译吗？', '不用每句都翻译，只处理影响理解的难句。'],
      ['双语字幕能帮助口语吗？', '能帮助理解表达含义，但口语提升还需要跟读和复述。'],
      ['GoodScriber 支持双语字幕学习吗？', '支持。你可以生成字幕后做翻译，并用双语内容辅助学习。']
    ]
  },
  {
    slug: 'jingting-yingyu-zenme-zuo',
    title: '英语精听怎么做才有效？',
    description: '有效的英语精听不是把整段音频循环很多遍，而是先听大意，再用字幕定位没听懂的句子，最后逐句回放、跟读和复述。本文把精听拆成可以照着做的步骤，帮你把听力问题变成具体的训练动作。',
    tldr: '有效的英语精听不是把一段音频循环很多遍，而是先听大意，再找出具体没听懂的句子。用字幕和转写文本定位问题后，逐句回放、跟读、复述，才能把听力问题变成可训练的动作。',
    sections: [
      {
        heading: '精听的关键不是时长',
        body: [
          '很多人精听时会反复播放整段音频，但不知道自己到底卡在哪里。更好的方式是把音频拆成句子，找到漏听、误听和理解慢的地方。',
          'GoodScriber 的字幕和逐句播放适合做这种拆解式精听。'
        ]
      },
      {
        heading: '推荐精听流程',
        list: [
          '先完整听一遍，不暂停。',
          '生成字幕或转写文本。',
          '标出没听清的句子。',
          '逐句回放 3 到 5 次。',
          '跟读并用自己的话复述这一句。'
        ]
      },
      {
        heading: '精听动作对照',
        table: {
          headers: ['问题', '定位方法', '练习动作'],
          rows: [
            ['听不出单词', '看英文字幕确认', '回放并跟读'],
            ['知道词但反应慢', '看整句结构', '复述句子意思'],
            ['连读弱读听不出', '对比原音和字幕', '模仿节奏和停顿']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '你可以用一段 BBC 6 Minute English 做精听。先听完整内容，再用 GoodScriber 生成字幕，挑出 8 个没听清的句子逐句练习。'
        ]
      }
    ],
    faqs: [
      ['英语精听每天练多久合适？', '10 到 20 分钟就够。重点是处理具体句子，不是堆时长。'],
      ['精听一定要逐字听写吗？', '不用每次都逐字听写。对多数学习者来说，定位难句、回放和复述更容易坚持。'],
      ['精听适合初学者吗？', '适合，但材料要短，语速不要太快。'],
      ['精听能提高口语吗？', '能间接帮助口语。把难句跟读和复述出来，听力材料就会变成输出材料。'],
      ['GoodScriber 怎么辅助精听？', '它可以生成字幕和转写文本，帮助你按句定位、回放、翻译和跟读。']
    ]
  },
  {
    slug: 'boke-lian-kouyu-fangfa',
    title: '英语播客怎么用来练口语？',
    description: '用英语播客练口语，不要直接听完整集：选 1 到 3 分钟片段，生成字幕，挑出自己真的会用的句子，逐句模仿语气、停顿和连接词，最后用自己的场景复述。本文给出完整的播客口语练习流程。',
    tldr: '用英语播客练口语，最好不要直接听完整集。选 1 到 3 分钟片段，生成字幕，挑出你真的会用的句子，逐句模仿语气、停顿和连接词，最后用自己的场景复述。',
    sections: [
      {
        heading: '为什么播客适合练口语',
        body: [
          '播客里有自然语速、真实停顿和口语连接方式，比教材句子更接近真实表达。问题是完整节目太长，直接听容易变成泛听。'
        ]
      },
      {
        heading: '播客口语练习流程',
        list: [
          '选一个你感兴趣的话题片段。',
          '用 GoodScriber 生成字幕。',
          '挑出 5 个你想学会说的句子。',
          '逐句跟读，模仿停顿和语气。',
          '换成自己的经历复述一遍。'
        ]
      },
      {
        heading: '适合挑哪些句子',
        table: {
          headers: ['句子类型', '练习价值', '例子方向'],
          rows: [
            ['观点句', '训练表达立场', 'I think the main issue is...'],
            ['转折句', '训练逻辑连接', 'That said, I still believe...'],
            ['经历句', '训练故事表达', 'What happened was...']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '如果你在准备英语会议，可以找一段商业播客，截取嘉宾回答问题的片段，把里面的观点句和转折句练到能自然说出来。'
        ]
      }
    ],
    faqs: [
      ['播客练口语要不要选母语者内容？', '可以选母语者内容，但清晰度和话题相关性更重要。'],
      ['一集播客要练完吗？', '不用。一个短片段练透，比整集听完更适合口语训练。'],
      ['播客字幕有什么用？', '字幕能帮你确认具体表达，再把听到的句子变成可模仿的材料。'],
      ['播客跟读会不会太难？', '可以先选慢速、清晰、话题熟悉的片段。'],
      ['GoodScriber 能处理播客音频吗？', '你可以上传音频文件生成字幕和文本，再用于跟读、翻译和复习。']
    ]
  },
  {
    slug: 'yingyu-tingli-tingbudong-zenmeban',
    title: '英语听力总是听不懂怎么办？',
    description: '英语听力听不懂，通常是词汇不熟、连读弱读、语速反应慢和句子结构不清混在一起。本文教你先用字幕定位卡住的句子，再判断属于哪类问题，最后逐句回放和跟读做针对练习，比盲目多听更有效。',
    tldr: '英语听力听不懂，通常不是一个问题，而是词汇不熟、连读弱读、语速反应慢、句子结构不清混在一起。先用字幕定位卡住的句子，再判断原因，最后逐句回放和跟读，比盲目多听更有效。',
    sections: [
      {
        heading: '先判断卡在哪里',
        body: [
          '如果看字幕就懂，问题多半在声音识别；如果看字幕也不懂，问题可能是词汇或句子结构。判断清楚后，练习才有方向。'
        ]
      },
      {
        heading: '四类问题的处理方式',
        table: {
          headers: ['听不懂原因', '表现', '练习动作'],
          rows: [
            ['词汇不熟', '看字幕也不懂', '查词并保存例句'],
            ['连读弱读', '单词认识但听不出', '慢速回放并跟读'],
            ['语速反应慢', '听完才反应过来', '短句循环训练'],
            ['句子太长', '前半句懂后半句丢', '拆句理解再复述']
          ]
        }
      },
      {
        heading: '推荐练习流程',
        list: [
          '选一段短音频。',
          '先听一遍并标记听不懂的位置。',
          '生成字幕确认具体句子。',
          '判断是词汇、发音还是结构问题。',
          '只练这些句子，不重复刷整段。'
        ]
      },
      {
        heading: '真实使用场景',
        body: [
          '你听一段 TED-Ed 时发现连续三句都没跟上，可以把视频转成字幕，找出具体句子，再分别处理生词、连读和长句结构。'
        ]
      }
    ],
    faqs: [
      ['英语听力差是不是词汇量不够？', '有时是词汇问题，但也可能是连读、弱读、语速和句子结构问题。'],
      ['听不懂时要不要马上看字幕？', '先听一遍再看字幕。直接看字幕会降低听力刺激。'],
      ['反复听整段有用吗？', '有一定帮助，但更有效的是定位具体难句后逐句练。'],
      ['听力和口语可以一起练吗？', '可以。把听不懂的句子跟读出来，能同时训练声音识别和表达。'],
      ['GoodScriber 适合解决哪类听力问题？', '它适合定位难句、生成字幕、逐句回放、翻译难句和跟读练习。']
    ]
  },
  {
    slug: 'yasi-tingli-cuoti-jingting',
    title: '雅思听力错题怎么做精听复盘？',
    description: '雅思听力错题不要只看答案解析：回到原音频，找到答案句和同义替换，生成字幕后逐句检查自己漏听了什么，再把答案句跟读和复述出来。本文给出一套可以直接照着做的雅思听力错题精听复盘流程。',
    tldr: '雅思听力错题不要只看答案解析。更有效的方法是回到原音频，找到答案句和同义替换，生成字幕后逐句检查自己漏听了什么，再把答案句跟读和复述出来。',
    sections: [
      {
        heading: '错题复盘要回到声音',
        body: [
          '很多考生只看文字解析，但雅思听力丢分常常发生在声音层面，比如弱读、数字、拼写、同义替换和干扰信息。'
        ]
      },
      {
        heading: '复盘步骤',
        list: [
          '把错题对应音频片段截出来。',
          '生成字幕或转写文本。',
          '找到答案出现的句子。',
          '标出同义替换和干扰信息。',
          '回放答案句并跟读。'
        ]
      },
      {
        heading: '错题类型对照',
        table: {
          headers: ['错题类型', '复盘重点', '练习动作'],
          rows: [
            ['数字日期', '弱读和连读', '慢速回放'],
            ['选择题', '同义替换', '标出原文表达'],
            ['填空题', '拼写和词性', '听写答案句']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '做完一套雅思听力后，把错题音频上传到 GoodScriber，生成字幕，直接定位答案句。你可以看到自己是没听到关键词，还是被干扰项带走了。'
        ]
      }
    ],
    faqs: [
      ['雅思听力错题要不要全文精听？', '优先精听错题相关片段。全文精听耗时很长，不一定适合每次复盘。'],
      ['答案句要不要背下来？', '不用死背，但要理解同义替换和常见表达。'],
      ['字幕会不会影响雅思听力训练？', '先听再看字幕，字幕用于复盘，不用于第一次做题。'],
      ['错题复盘多久合适？', '一题 3 到 5 分钟就够，重点是找出具体原因。'],
      ['GoodScriber 能帮雅思听力复盘什么？', '它能把音频变成字幕，帮助定位答案句、回放难句和整理错题表达。']
    ]
  },
  {
    slug: 'yingyu-mianshi-kouyu-lianxi',
    title: '英语面试口语怎么自己练？',
    description: '自己练英语面试口语，可以先写好常见问题的答案，用文字转语音生成参考音频，逐句跟读节奏和停顿，练熟后关掉文本用自己的话复述。本文介绍这套练习流程，重点提高表达清晰度，避免听起来像背稿。',
    tldr: '自己练英语面试口语，可以把常见问题答案写下来，用文字转语音生成参考音频，逐句跟读节奏和停顿。练熟后关掉文本，用自己的话复述，避免像背稿。',
    sections: [
      {
        heading: '面试口语练什么',
        body: [
          '面试口语不只看语法，还看回答是否清楚、节奏是否自然、重点是否突出。',
          'TTS 和跟读适合帮你先建立一个稳定的表达模型。',
          '可能有些单词的发音自己都意识到不准，这时可以用 TTS 生成标准发音，先跟读纠正。'
        ]
      },
      {
        heading: '自练流程',
        list: [
          '列出 5 个高频面试问题。',
          '每题写 60 到 90 秒答案。',
          '用 GoodScriber 生成语音。',
          '逐句跟读并标出停顿。',
          '关掉文本后复述答案。'
        ]
      },
      {
        heading: '常见问题怎么练',
        table: {
          headers: ['问题类型', '练习重点', '输出目标'],
          rows: [
            ['自我介绍', '结构清楚', '60 秒讲完重点'],
            ['项目经历', '动词和结果', '讲清做了什么'],
            ['行为问题', '故事节奏', '按背景、行动、结果回答']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '你可以把“Tell me about yourself”的答案放进 GoodScriber 生成语音，先跟读 5 遍，再关掉文本录一遍自己的回答。'
        ]
      }
    ],
    faqs: [
      ['英语面试答案要不要背？', '不建议整段死背。建议练结构和关键句，再用自己的话说出来。'],
      ['TTS 适合面试口语吗？', '适合做参考音频，帮助你练节奏、重音和停顿。'],
      ['每个答案多长合适？', '多数问题 60 到 90 秒比较合适，太长容易失焦。'],
      ['怎么避免听起来像背稿？', '跟读后要脱稿复述，并替换成自己的真实表达。'],
      ['GoodScriber 可以用来练哪些面试题？', '自我介绍、项目经历、行为问题、职业规划等都可以转成语音后练习。']
    ]
  },
  {
    slug: 'yingyu-duanju-fuxi-fangfa',
    title: '英语短句怎么复习才记得住？',
    description: '英语短句最好不要孤立背：把短句放回原音频和字幕里，先理解它出现的场景，再回放原句、跟读，并替换关键词造新句子。本文介绍从听力材料里复习短句的具体方法，比单独背单词和短语记得更牢。',
    tldr: '英语短句最好不要孤立背。把短句放回原音频和字幕里，先理解它在什么场景出现，再回放原句、跟读、替换关键词造句，记忆会更稳定。',
    sections: [
      {
        heading: '短句要带语境复习',
        body: [
          '只把短句抄到笔记里，很容易忘。保留原音频和字幕，可以让你记住它的语气、使用场景和前后逻辑。'
        ]
      },
      {
        heading: '短句复习流程',
        list: [
          '从听力材料里挑 5 到 10 个短句。',
          '保存原句和对应字幕。',
          '回放原音并跟读。',
          '替换关键词造 2 个新句子。',
          '隔天再听原句复习。'
        ]
      },
      {
        heading: '短句类型对照',
        table: {
          headers: ['短句类型', '复习重点', '练习动作'],
          rows: [
            ['观点句', '表达立场', '换话题造句'],
            ['连接句', '逻辑过渡', '放进回答里用'],
            ['描述句', '细节表达', '替换名词和形容词']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '你听播客时发现一句 “That is exactly what I mean”，可以保存原句，回放跟读，然后换成自己的场景说三遍。'
        ]
      }
    ],
    faqs: [
      ['英语短句要背中文意思吗？', '可以理解中文意思，但复习重点要回到英文原句和使用场景。'],
      ['每天复习多少短句合适？', '5 到 10 句比较合适，数量太多会很难复用。'],
      ['短句复习能提高口语吗？', '能。前提是你要跟读、造句、复述，而不是只收藏。'],
      ['要不要整理成笔记？', '可以整理，但最好保留原音频或字幕位置。'],
      ['GoodScriber 怎么帮短句复习？', '它可以把音频变成字幕，方便你定位、保存和回放具体句子。']
    ]
  },
  {
    slug: 'meitian-kai-kou-shuo-yingyu',
    title: '为什么学英语要每天开口说？肌肉记忆怎么练？',
    description: '每天开口说英语，可以让舌头、嘴唇、下颌、声带和呼吸逐渐熟悉英语的发音动作，只听和默读还不够。本文提供一套每天 10 分钟的跟读、录音和重复训练方法，帮你把不熟悉的发音动作练成更自动的肌肉记忆。',
    tldr: '英语发音需要舌头、嘴唇、下颌、声带和呼吸协调完成。不同语言常用的口型、舌位和发音节奏不同，所以只听和默读还不够。每天选几句话真正张嘴跟读、录音和重复，才能把不熟悉的发音动作逐渐练成更自动的程序化记忆。',
    sections: [
      {
        heading: '口语里的“肌肉记忆”是什么意思',
        body: [
          '“肌肉记忆”是一种通俗说法。真正形成的是大脑对发音动作顺序的程序化记忆：什么时候抬舌、怎样收圆嘴唇、如何控制气流，以及重音和停顿怎样衔接。',
          '英语和中文使用的是同一套发音器官，但常用的舌位、口型、气流方式和动作组合并不完全相同。刚开始说英语时觉得嘴巴不听使唤，通常说明这些动作还需要有意识控制。',
          '重复正确动作后，大脑调用这些发音动作会越来越快，说话时就能把更多注意力放在意思和表达上。'
        ]
      },
      {
        heading: '为什么只听英语还不够',
        body: [
          '听力输入能帮助你辨认声音，却不能代替实际发音。知道一个单词怎么读，和嘴巴能稳定、连贯地把它说出来，是两个不同的训练任务。',
          '默读时，舌头、嘴唇、下颌和呼吸没有完成真实动作。每天开口练习的价值，就是让听到的声音转化成自己能够重复的动作。'
        ]
      },
      {
        heading: '每天 10 分钟怎么练口语肌肉记忆',
        list: [
          '选一段 30 到 60 秒的英语音频，内容以基本能理解为准。',
          '先完整听一遍，再用字幕确认单词和句意。',
          '每次只练一句，观察嘴唇、舌头和下颌的动作。',
          '跟着原音说 3 到 5 遍，保持正常音量，不要只在心里念。',
          '录下最后一遍，对比容易卡住的音、重音和连读。',
          '第二天先复练昨天最难的两句话，再开始新内容。'
        ]
      },
      {
        heading: '常见英语发音动作练什么',
        table: {
          headers: ['练习对象', '动作重点', '常见问题'],
          rows: [
            ['th 音', '舌尖轻触或伸到上下齿之间并送气', '用 s、z、d 等熟悉音代替'],
            ['r 和 l', '区分舌尖位置与舌身形状', '两个音听得出但说不稳定'],
            ['词尾辅音', '把最后的辅音动作做完整', '为了说得快而吞掉结尾'],
            ['重音和弱读', '让重读音节突出，功能词适当减弱', '每个单词读得一样重'],
            ['连读和节奏', '把相邻单词自然衔接', '逐词停顿，句子听起来断裂']
          ]
        }
      },
      {
        heading: '真实使用场景',
        body: [
          '假设你要练一句 “I really appreciate your help”。可以把参考音频或文本放进 GoodScriber，生成可逐句播放的语音和字幕。先听原句，再正常音量跟读 5 遍，录下最后一遍，重点检查 really 的 r、appreciate 的重音以及整句话是否连贯。第二天先复练这句话，直到不看字幕也能自然说出。'
        ]
      }
    ],
    faqs: [
      ['每天开口说英语真的有用吗？', '有用。稳定开口能训练发音动作、节奏和从想法到声音的转换，但要尽量模仿清楚的参考音频并及时纠正明显错误。'],
      ['每天练多久才能形成口语肌肉记忆？', '没有统一天数。每天高质量练习 10 到 20 分钟通常比偶尔集中练很久更容易保持动作熟悉度。'],
      ['只跟读不录音可以吗？', '可以开始练，但录音能帮助你发现自己没有意识到的吞音、重音和节奏问题。'],
      ['跟读时一定要大声吗？', '不需要喊，但要用正常说话音量完成真实的舌位、口型和气流动作。只动嘴不出声，训练效果会受限。'],
      ['GoodScriber 怎么帮助每天开口练英语？', '你可以用自己的音频或文本生成逐句练习材料，反复播放短句、查看字幕，并围绕难句进行跟读和复练。']
    ]
  },
  {
    slug: 'bbc-liu-fenzhong-yingyu-gendu',
    updatedAt: '2026-10-07',
    title: 'BBC 六分钟英语怎么跟读？',
    description: '用 BBC 六分钟英语（6 Minute English）练跟读的具体做法：一集分两三次练，先听大意，再对着字幕逐句跟读，录下卡壳的句子，最后不停顿连续跟读一分钟。附 20 分钟练习安排和常见错误。',
    tldr: '选一集六分钟的节目，分两三次短时间练完。先不看字幕听一遍大意，再对着字幕逐句跟读，把卡壳的句子录下来对比，最后挑一分钟不停顿地连续跟读。把一集练熟，比每天换一集新的更能练出口语。',
    materialLinks: [
      { label: 'BBC 六分钟英语：配同步字幕逐句跟读', path: '/zh/material/bbc6minute' },
      { label: '全部听力素材', path: '/zh/material' }
    ],
    sections: [
      {
        heading: '为什么六分钟英语适合跟读',
        body: [
          'BBC 六分钟英语（6 Minute English）是 BBC Learning English 的节目，两位主持人用大约六分钟聊一个话题，并顺带讲解几个和话题相关的词。语音是清晰的英式英语，语速适中，接近日常对话。',
          '这几点正好适合跟读：一集很短，练得完；两个人一来一回，有自然的语调和接话节奏可以模仿；重点词在节目里就解释了，不用老停下来查。',
          '它面向的是中级学习者。如果大部分句子重播几遍还是跟不上，先用更慢的材料，过一段时间再回来练。'
        ]
      },
      {
        heading: '具体怎么练',
        list: [
          '挑一集自己感兴趣的话题，先不看任何文字完整听一遍，只抓大意。',
          '打开逐句字幕，把没听出来的词和短语查清楚。',
          '逐句跟读：播一句，开口重复一句，反复重播，直到重音和停顿接近主持人。',
          '挑 5 到 10 句最难的录音，看发音反馈里标出了哪些问题词。',
          '选一分钟的片段不停顿地连续跟读，比主持人慢半拍开口。',
          '把两三个用得上的表达存进句子本，第二天回到同一集继续练。'
        ]
      },
      {
        heading: '20 分钟练习安排',
        table: {
          headers: ['时间', '做什么', '练的是什么'],
          rows: [
            ['0–6 分钟', '不看字幕完整听一遍', '整体理解'],
            ['6–14 分钟', '对着字幕逐句跟读前半集', '发音、重音、连读'],
            ['14–18 分钟', '录下最难的几句，和原音对比', '具体的问题词'],
            ['18–20 分钟', '挑一分钟不停顿连续跟读', '节奏和流利度']
          ]
        }
      },
      {
        heading: '常见错误',
        list: [
          '想一口气把整集跟读完。应该拆成小段，反复练。',
          '盯着字幕念，没有在模仿声音。字幕用来学会这一句，开口重复时把眼睛移开。',
          '从来不录音。不录下来，很难发现自己把哪些词读走样了。',
          '每天换一集新的。流利度来自把同样的句子重复到顺口。'
        ]
      },
      {
        heading: '使用场景示例',
        body: [
          '一位学习者在 GoodScriber 听力素材库里打开一集六分钟英语。第一天先听一遍，再逐句跟读前三分钟，录了 6 句。第二天练完后半集，把那 6 句重录一遍，再不停顿地跟读开头一分钟。第三天把整集完整跟读一遍，然后换下一集。'
        ]
      }
    ],
    faqs: [
      ['BBC 六分钟英语适合用来跟读吗？', '适合中级学习者。每集很短，语音清晰、接近日常对话，重点词在节目里有解释。初学者可能觉得语速偏快，建议先从更慢的材料开始。'],
      ['跟读一集要多长时间？', '一集建议分两到三次、每次 20 分钟左右练完。一次练完往往是在赶进度，没有真正重复。'],
      ['跟读时要不要看字幕？', '学一句新句子时看字幕。声音熟悉以后，重复时把眼睛从文字上移开，这样模仿的是声音，不是在朗读。'],
      ['六分钟英语是英音还是美音？', '是英式英语。如果你的目标是美式发音，可以用它练听力和词汇，口音跟读另选美音材料。'],
      ['在哪里可以逐句跟读六分钟英语？', 'GoodScriber 听力素材库里有 BBC 六分钟英语，配同步字幕，支持逐句回放、录音和发音练习反馈。你也可以上传自己的音频，用同样的方式练。']
    ]
  }
]

export const zhLearnArticles = zhLearnArticleDrafts.map(article => ({
  ...article,
  author: {
    name: 'GoodScriber 编辑团队',
    type: 'Organization',
    url: 'https://www.goodscriber.com/'
  },
  publishedAt: ARTICLE_PUBLISHED_AT[article.slug] || '2026-07-09',
  // 旧文章统一在 2026-07-19 修订过；之后的文章在草稿里自己写 updatedAt
  updatedAt: article.updatedAt || '2026-07-19',
  methodology: '本文把 GoodScriber 中可重复执行的练习流程，与下方列出的外部研究结合。文中的使用场景是操作示例，不代表真实用户评价。学习效果会受到材料难度、英语水平、练习质量和反馈方式影响。',
  sources: (ARTICLE_EVIDENCE[article.slug] || []).map(key => EVIDENCE_SOURCES[key])
}))

export function getZhLearnArticleBySlug(slug) {
  return zhLearnArticles.find(article => article.slug === slug)
}
